$('.filter-form--params-x1 .btn-toolbar, .filter-form--params-x2 .btn-toolbar').hide();

$(document).ready( function(){
    FilterClubData();  
});

function FilterClubData() {
    var container = $('.category-list.icon-tiles');

    // forms that filter by single param (ie Region OR Category)
	if ($('.filter-form--params-x1').length > 0){
        var form = $('.filter-form--params-x1');
        if(form.data('url')){
            form.find('select').on('change', function(e){
                form.find('select').addClass('loading');
                $.ajax({
                    url: form.data('action'),
                    method: 'POST',
                    // contentType: 'application/json',
                    data: form.serialize()
                }).done(function(response){
                    if (response.html){
                        container.replaceWith(response.html);
                    }
                }).fail(function(error){
                    console.error(error);
                }).always(function(){
                    form.find('select').removeClass('loading');
                });

                // window.location.href = form.data('url') + '/' + $(this).val() + '/';
                history.pushState({
                    id: 'find-a-club'
                }, 'Find a Club | Clubs New Zealand', form.data('url') + '/' + $(this).val() + '/');
            });
        }else{
            $('.filter-form .btn-toolbar').show();
        }
    }
    
    // forms that filter by two params (ie Region AND Category)
    if ($('.filter-form--params-x2').length > 0){
        var form = $('.filter-form--params-x2'),
            region_field = form.find('select[name=Region]'),
            category_field = form.find('select[name=Category]'),
            region = 'all',
            category = 'all';
        if(form.data('url')){
            form.find('select').on('change', function(e){
                form.find('select').attr('disabled','disabled').addClass('loading');
                if(region_field.val()){
                    region = region_field.val();
                }
                if(category_field.val()){
                    category = category_field.val();
                }
                var url = form.data('url');
                if (!url.endsWith('/')) {
                    url += '/';
                }
                window.location.href = url + region + '/' + category + '/';
            });
        }else{
            $('.filter-form .btn-toolbar').show();
        }
    }

    // handle browser back/forward buttons
    window.onpopstate = function(e) {
        location.reload();     
    };

     
}

$(document).ajaxComplete(function() {
    FilterClubData();
});